/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Dashboard_Billing_Past_BilledInputs */



/**
* | output |
* | --- |
* | "Billed {amount}" |
*
* @param {Dashboard_Billing_Past_BilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_past_billed = /** @type {((inputs: Dashboard_Billing_Past_BilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Past_BilledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abgerechnet ${i?.amount}`)
	return /** @type {LocalizedString} */ (`Billed ${i?.amount}`)
});